require('./../Css/style.css');

function initVideoPanel() {
    const videoPanelsDom = document.querySelectorAll(".js-video-panel");
    const videoPanels = Array.from(videoPanelsDom);
    const root = document.getElementsByTagName('html')[0];

    videoPanels.forEach((panel) => {
        const popup = panel.querySelector(".js-video-popup");
        const playBtn = panel.querySelector(".js-video-play-btn");
        const closeBtn = panel.querySelector(".js-popup-close-btn");
        const popupContent = panel.querySelector(".js-video-popup-content");
        const video = panel.querySelector(".js-video-frame");
        const videoUrl = video.dataset.url;

        playBtn.addEventListener("click", () => {
            showPopup(popup, video, videoUrl, root);
        });

        closeBtn.addEventListener("click", () => {
            hidePopup(popup, video);
        });

        popup.addEventListener("click", (e) => {
            if (e.target !== popupContent) {
                hidePopup(popup,video);
            }
        });
    });

    function showPopup(popup, video, videoUrl, root) {
        popup.classList.remove('_hide');       
        video.setAttribute("src", videoUrl);
        root.classList.add('_hide-scroll');
    }

    function hidePopup(popup, video) {
        popup.classList.add('_hide');
        video.setAttribute("src", '');
    }
};

export default initVideoPanel;


// WEBPACK FOOTER //
// ./uPortal/Core/Panels/VideoPanel/Js/index.js